import React from 'react'
import { bindActionCreators, compose } from 'redux'
import { Row, Col, Steps, Icon, Spin, Tag } from 'antd'
import moment from 'moment-timezone'
import { connect } from 'react-redux'
import { Helmet } from 'react-helmet'
import PropTypes from 'prop-types'
import InfiniteScroll from 'react-infinite-scroller'
import { withTranslation } from 'react-i18next'

import { CheckHostExist, CompetitionNavigation, AppContainer } from '@client/containers/index'
import { Banner, AspectRatioImage, Image } from '@client/components/index'
import { IMAGE_RATIOS } from '@client/constants/index'
import actions from '@client/actions'
import emptyHostCover from '@client/images/default-avatar.png'

import styles from './Host.styl'

const { Step } = Steps

const mapStateToProps = (state) => {
  return {
    competition: state.competition.data,
    host: state.host.data,
  }
}

const mapDispatchToProps = (dispatch) => {
  return { actions: bindActionCreators(actions, dispatch) }
}

class Host extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      teamList: [],
      hasMore: true,
      loading: false,
      currentPage: 0,
    }
  }

  static propTypes = {
    actions: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    host: PropTypes.object.isRequired, // form check
    t: PropTypes.func.isRequired,
  }

  static defaultProps = {}

  componentDidMount() {
    this.props.actions.setLoadingMask({ isEnable: false })
  }

  componentWillUnmount() {
    this.props.actions.setLoadingMask({ isEnable: true })
  }

  renderTimeLine = () => {
    const { t, host } = this.props
    const timeLine = [
      {
        title: t('報名開始'),
        date: moment(host.signup_start_time).format('YYYY-MM-DD'),
        icon: 'usergroup-add',
        status: 'wait',
      },
      {
        title: t('報名結束'),
        date: moment(host.signup_end_time).format('YYYY-MM-DD'),
        icon: 'usergroup-add',
        status: 'wait',
      },
      {
        title: t('比賽開始'),
        date: moment(host.activity_start_time).format('YYYY-MM-DD'),
        icon: 'rocket',
        status: 'wait',
      },
      {
        title: t('比賽結束'),
        date: moment(host.activity_end_time).format('YYYY-MM-DD'),
        icon: 'rocket',
        status: 'wait',
      },
    ]
    const now = {
      title: 'Today',
      date: moment().format('YYYY-MM-DD'),
      icon: 'environment',
      status: 'process',
    }

    let index
    let isSame = false
    for (index = 0; index < timeLine.length; index++) {
      if (moment(now.date).isSame(timeLine[index].date)) {
        isSame = true
        break
      } else if (moment(now.date).isBefore(timeLine[index].date)) {
        break
      }
      timeLine[index].status = 'finish'
    }
    if (isSame) {
      timeLine[index].title = `${timeLine[index].title} (Today) `
      timeLine[index].status = 'process'
    } else {
      timeLine.splice(index, 0, now)
    }

    return (
      <Row type="flex" justify="center">
        <Col span={20}>
          <Steps
            size="small"
            status="wait"
            direction="horizontal"
            current={index}
            className={styles.timeLine}
          >
            {timeLine.map((timeObj) => {
              return (
                <Step
                  key={timeObj.title}
                  title={<div className={styles.timeLineTitle}>{timeObj.title}</div>}
                  icon={<Icon type={timeObj.icon} />}
                  status={timeObj.status}
                  description={
                    <div
                      className={`${styles.timeLineDescription} ${
                        timeObj.status === 'process' ? styles.highlight : ''
                      }`}
                    >
                      {timeObj.date}
                    </div>
                  }
                />
              )
            })}
          </Steps>
        </Col>
      </Row>
    )
  }

  handleInfiniteOnLoad = () => {
    this.setState({
      loading: true,
    })

    const {
      match: {
        params: { competitionId, hostId },
      },
    } = this.props

    const nextPage = this.state.currentPage + 1

    this.props.actions
      .getTeamList(competitionId, hostId, {
        pageNumber: nextPage,
        pageSize: 9,
        filter: 'is_pay=true',
        sort: '-total_score',
      })
      .then(({ payload }) => {
        if (!payload.data.length) {
          this.setState({
            hasMore: false,
            loading: false,
          })
          return
        }
        this.setState((state) => ({
          teamList: state.teamList.concat(payload.data),
          hasMore: true,
          loading: false,
          currentPage: nextPage,
        }))
      })
  }

  handleTeamClick = (teamId) => (event) => {
    const {
      history: { push },
      match: {
        params: { competitionId, hostId },
      },
    } = this.props

    push(`/competition/${competitionId}/host/${hostId}/team/${teamId}`)
  }

  handleSignUpClick = () => {
    const {
      history: { push },
      match: {
        params: { competitionId, hostId },
      },
    } = this.props

    push(`/competition/${competitionId}/host/${hostId}/sign_up`)
  }

  render() {
    const { host, match, t } = this.props
    const { competition = {} } = host
    return (
      <AppContainer style={{ paddingTop: 0 }}>
        <Helmet>
          <title>{host.name ? `${host.name} | ${t('賽務系統')}` : t('賽務系統')}</title>
        </Helmet>

        <Banner backgroundImage={competition.cover} disabledLogo />

        <Row type="flex" justify="center" id="pageTitle">
          <CompetitionNavigation match={match} />
        </Row>

        {this.renderTimeLine()}

        <InfiniteScroll
          loadMore={this.handleInfiniteOnLoad}
          hasMore={!this.state.loading && this.state.hasMore}
          className={styles.teamContainer}
        >
          <Row type="flex" justify="start" gutter={15}>
            {this.state.teamList.map((team) => {
              return (
                <Col key={team.id} xs={24} sm={12} md={12} lg={6}>
                  <div className={styles.card} onClick={this.handleTeamClick(team.id)}>
                    <AspectRatioImage
                      src={team.cover}
                      defaultSrc={emptyHostCover}
                      ratio={IMAGE_RATIOS.TEAM}
                    />
                    <div className={styles.footer}>
                      <div className={styles.teamName}>{team.name}</div>
                      <div className={styles.divider} />
                      <div className={styles.score}>
                        <Tag>{team.total_score}</Tag>
                      </div>
                      <div className={styles.teamAvatarContainer}>
                        {team.users.map((user) => (
                          <Image key={user.id} className={styles.avatar} src={user.cover} />
                        ))}
                      </div>
                    </div>
                  </div>
                </Col>
              )
            })}

            {this.state.loading && this.state.hasMore && (
              <div className={styles.loadingContainer}>
                <Spin />
              </div>
            )}
          </Row>
        </InfiniteScroll>
      </AppContainer>
    )
  }
}

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  CheckHostExist,
  withTranslation(),
)(Host)
